import { render } from "./Mostrar-Solicitudes.vue?vue&type=template&id=2cfbc1de&scoped=true"
import script from "./Mostrar-Solicitudes.vue?vue&type=script&lang=js"
export * from "./Mostrar-Solicitudes.vue?vue&type=script&lang=js"

import "./Mostrar-Solicitudes.vue?vue&type=style&index=0&id=2cfbc1de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfbc1de"]])

export default __exports__